// extracted by mini-css-extract-plugin
export default {"SectionContainer":"Overview-module__SectionContainer--k14wH","TableFooter":"Overview-module__TableFooter--xfJ1X"};